export default {
    data() {
        return {
        }
    },
    components: {
    },
    mounted() {
        this.initializeAnimations();
    },
    methods: {
        goToContact() {
            this.$router.push('/contact'); 
        },
        
        initializeAnimations() {
            const cards = document.querySelectorAll(".component__product-overview--card");

            const observerOptions = {
                threshold: 0.1,
                rootMargin: "0px 0px -50px 0px",
            };

            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.style.opacity = "1";
                        entry.target.style.transform = "translateY(0)";
                    }
                });
            }, observerOptions);

            cards.forEach((card) => {
                card.style.opacity = "0";
                card.style.transform = "translateY(30px)";
                card.style.transition = "all 0.8s ease-out";
                observer.observe(card);
            });
        }
    },
    watch: {
    },
    beforeDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
};